import React from 'react'
import styled from 'styled-components'
import HomeSection1 from './HomeSection1'
import { useInView } from 'react-intersection-observer'
import Header from '../../Header'
import colors from '../../../styles/colors'

const HeaderStyled = styled(Header)`
  opacity: ${({ isVisible }) => (isVisible ? 1 : 0)};
  transition: opacity 0.3s ease;
  position: fixed;
  left: 0;
  top: 0;
  background-color: ${colors.grayLightBg};
  border-bottom: 1px solid rgba(0, 0, 0, 0.03);
  z-index: ${({ isVisible }) => (isVisible ? 1000 : -1)};
`

export default () => {
  const { ref, inView } = useInView({
    threshold: 0,
  })

  return (
    <div ref={ref}>
      <HomeSection1 />
      <HeaderStyled isVisible={!inView} isTransparent />
    </div>
  )
}
